import React from 'react';

function LogoComponent(props) {
  const { url, className, style } = props;

  return (
    <div
      className={className}
      style={style ? { ...baseSTyle, ...style } : baseSTyle}
    >
      <img
        src={url}
        alt="PAVE"
        style={{
          maxWidth: '100%',
          maxHeight: '100%',
        }}
      />
    </div>
  );
}

export default LogoComponent;

const baseSTyle = {
  zIndex: '3',
  width: '100%',
  height: '40px',
  margin: 'auto',
  position: 'relative',
  overflow: 'hidden',
  maxWidth: '85px',
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};
